/* unplugin-vue-components disabled */import script from "./Works.vue?vue&type=script&setup=true&name=Works&lang=js"
export * from "./Works.vue?vue&type=script&setup=true&name=Works&lang=js"

import "./Works.vue?vue&type=style&index=0&id=ef0338de&lang=scss"

const __exports__ = script;

export default __exports__